import React, {memo, useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay,Pagination,Navigation } from 'swiper';
import {useSelector} from 'react-redux';

import styles from './styles.module.scss';

import exploreBtn from '../../assets/img/public/icons/exploreBtn.svg';
import exploreBtnHover from '../../assets/img/public/icons/exploreBtnHover.svg';

// install Swiper modules
SwiperCore.use([Autoplay,Pagination,Navigation]);

const Index = memo((props) => {

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);

  const [ activeIndex, setActiveIndex ] = useState(0);
  const [btnNextLeftFlag, setBtnNextLeftFlag] = useState(false);
  const [btnNextRightFlag, setBtnNextRightFlag] = useState(false);


  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  const swiperTemp = () => {
    let interleaveOffset = 0.5; //视差比值
    return (
        <Swiper
            initialSlide={activeIndex}
            className="overseasSelectionSwiper"
            direction={'horizontal'}
            spaceBetween={0}
            autoplay={{
              "delay": 3000,
              "disableOnInteraction": false
            }}
            loop
            speed={1000}
            aria-grabbed
            watchSlidesProgress
            mousewheel
            keyboard
            navigation = {{
              nextEl: '.swiper-os-next',
              prevEl: '.swiper-os-prev',
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.activeIndex);
            }}
            onProgress={(swiper) => {
              for (let i = 0; i < swiper.slides.length; i++) {
                let slideProgress = swiper.slides[i].progress;
                let innerOffset = swiper.width * interleaveOffset;
                let innerTranslate = slideProgress * innerOffset;
                let isInnerTranslate = recReSizeReducer <= 750 ? `${innerTranslate / 100}rem` : `${innerTranslate}px`;
                swiper.slides[i].querySelector('.slide-inner').style.transform = `translate3d(${isInnerTranslate}, 0, 0)`;
              }
            }}
            onTouchStart={(swiper) => {
              for (let i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = '';
              }
            }}
            onSetTransition={(swiper, speed) => {
              for (let i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = speed + 'ms';
                swiper.slides[i].querySelector('.slide-inner').style.transition = speed + 'ms';
              }
            }}
            onTap={() => {
              props.handleEvent();
            }}
            
        >
          {props.config.data.map(item => {
            return (
                <SwiperSlide key={item.id} style={{ height: 'auto', cursor: 'pointer' }}>
                  <div className="slide-inner">
                    <div className="innerInfoBox">
                      <img src={item.img} alt="" />
                        <div className="descMap">
                          <h5 className="title"><span>{item.title}</span></h5>
                          <p className="text"><span>{item.subTitle}</span></p>
                          <div className="address">
                            <img src={item.icon} alt="" />
                            <span>{item.address}</span>
                          </div>
                        </div>
                    </div>
                  </div>
                </SwiperSlide>
            )
          })}
        </Swiper>
    )
  };

  /*
  const [btnNextLeftFlag, setBtnNextLeftFlag] = useState(false);
  const [btnNextRightFlag, setBtnNextRightFlag] = useState(false);

  exploreBtnHover
  */
  const handleHover = (event, type) => {
    if(type === 'btnLeft'){
      if(event.type === 'mousemove'){
        setBtnNextLeftFlag(true);
      }else{
        setBtnNextLeftFlag(false);
      }
    }else{
      if(event.type === 'mousemove'){
        setBtnNextRightFlag(true);
      }else{
        setBtnNextRightFlag(false);
      }
    }
    
  }

  const pointerCss = {cursor: 'pointer'};

  // 判断是：桌面/移动端
  return (
      <div className={normal()} ref={props.config.getRefs.innerRef} style={props.config.getRefs.innerStyles}>
        {swiperTemp()}
        <div 
          className="swiper-os-next" 
          style={{...pointerCss, transform: `rotate(180deg)`}}
          onMouseMove={(event) => handleHover(event, 'btnLeft')} 
          onMouseLeave={(event) => handleHover(event, 'btnLeft')}
        >
          <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="104" height="104" rx="52" fill="white" fillOpacity="0.05"/>
            <path d="M59.9472 62L68.9471 53L59.9472 44" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M67.88 52.9999L38 52.9999" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle style={{transition: `all 0.5s linear 0s`, opacity: btnNextLeftFlag ? 1 : 0}} opacity="0.8" cx="53" cy="53" r="44.5" stroke="white"/>
            <rect x="1" y="1" width="104" height="104" rx="52" stroke="white" strokeWidth="2"/>
          </svg>
        </div>
        <div 
          className="swiper-os-prev" 
          style={{...pointerCss, transform: `rotate(0deg)`}}
          onMouseMove={(event) => handleHover(event, 'btnRight')} 
          onMouseLeave={(event) => handleHover(event, 'btnRight')}
        >
          <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="104" height="104" rx="52" fill="white" fillOpacity="0.05"/>
            <path d="M59.9472 62L68.9471 53L59.9472 44" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M67.88 52.9999L38 52.9999" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle style={{transition: `all 0.5s linear 0s`, opacity: btnNextRightFlag ? 1 : 0}} opacity="0.8" cx="53" cy="53" r="44.5" stroke="white"/>
            <rect x="1" y="1" width="104" height="104" rx="52" stroke="white" strokeWidth="2"/>
          </svg>
        </div>
      </div>
  );
});
export default Index;
